export default [
    'formReportName',
    'shareType',
    'shareStatus',
    'dateRange.startDate',
    'dateRange.endDate'
];
